<template>
	<drawer
			title="Add address"
			z-index="100"
			@updateClose="onClose"
			@updateSave="onSave"
	>

		<div class="addAddress">
			<field
					:class-error="$v.state && $v.state.$error"
					margin="0 0 10px 0"
					width="300px"
					label="State"
					item-text="name"
					item-value="state_id"
					placeholder="Select state"
					:items="statesList"
					:autocompleteValue="state"
					@updateSelect="onAutocomplete($event, 'state')"
					is-select
					is-attach
					is-required
			></field>
			<field
					:class-error="$v.city && $v.city.$error"
					margin="0 0 10px 0"
					label="City"
					width="300px"
					placeholder="Select city"
					:setInputValue="city"
					@updateInput="onInput($event, 'city')"
					is-required

			></field>
			<field
					margin="0 0 10px 0"
					width="300px"
					label="Create ZIP"
					type="number"
					:setInputValue="zip"
					@updateInput="onInput($event, 'zip')"
					@updateAdd="onAdd"
					is-add
					add-text="add to list"
			></field>
			<div class="dividerTitle">ZIP</div>
			<template v-if="zipList.length">
				<div
						class="zip"
						v-for="(zip, idx) in zipList"
						:key="idx"
						:class="{
						'disabled': zip.disabled,
						'new': zip.new
					}"
				>
					<field
							:class-error="$v.zipList && $v.zipList.$each.$iter[idx].$error"
							margin="0"
							width="300px"
							type="number"
							:idx="idx"
							:is-disabled="zip.disabled"
							placeholder="Enter zip"
							:setInputValue="zip.value"
							@updateInput="onInputZip"
					></field>
					<div class="zipBtn">
						<button class="zipBtn_edit" @click="onEdit(idx)">
							<svg-sprite width="20" height="20" :icon-id="zip.disabled ? 'edit': 'safe'"></svg-sprite>
						</button>
						<button @click="onDelete(idx)">
							<svg-sprite width="20" height="20" :icon-id="zip.disabled ? 'deleteItem': 'close'"></svg-sprite>
						</button>
					</div>
				</div>
			</template>
					<div class="notText" v-else>Fill in the "Create ZIP" field and click "Add to list".</div>
			<div
					v-if="$v.zipList.$dirty && ($v.zipList.$error || !$v.zipList.minLength)"
					class="notText errorText"
			>
				Add at least one ZIP
			</div>
		</div>

	</drawer>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import Drawer from "@/shared/Drawer/Drawer";
import { required, minLength } from "vuelidate/lib/validators";
import { validationMixin } from "vuelidate";
export default {
	name: 'CitiesForm',
	mixins: [ validationMixin ],
	components: { Drawer },
	props: {
		cityId: Number
	},
	computed: mapGetters([ 'citiesItem', 'statesList' ]),
	data: () => ({
		state: null,
		city: null,
		zip: null,
		zipValue: '',
		zipList: []
	}),
	validations: {
		state: { required },
		city: { required },
		zipList: {
			required,
			minLength: minLength(1),
			$each: {
				value: { required },
			}
		}
	},
	methods: {
		...mapActions([ 'setAlert', 'getCitiesItem', 'onCitiesSave' ]),
		onClose(isRefresh) {
			this.$emit('updateClose', isRefresh);
		},
		onAutocomplete({ value }, key) {
			this[key] = value?.state_id ?? value;
		},
		onInput({ value }, key) {
			this[key] = value;
		},
		onInputZip({ value }) {
			this.zipValue = value;
		},
		onAdd() {
			if (!this.zip) return;

			this.zipList.push({ value: this.zip, disabled: true, new: true });
			this.zip = null;
			this.$v.zipList.$touch();
		},
		onDelete(idx) {
			if (this.zipList[idx].disabled) {
				this.zipList.splice(idx, 1);
			} else {
				this.$set(this.zipList[idx], 'disabled', true);
				this.zipValue = '';
			}

			this.$v.zipList.$touch();
		},
		onEdit(idx) {
			this.$set(this.zipList[idx], 'disabled', !this.zipList[idx].disabled);
			if (this.zipList[idx].disabled && this.zipValue) {
				this.zipList[idx].value = this.zipValue;
				this.zipList[idx].new = true;
			}
		},
		async onSave() {
			this.$v.$touch();
			if (!this.$v.$error) {
				const { city, state, zipList } = this.$data;
				const zip = zipList.map(({ id, value }) => ({ id, value }));
				const values = {
					city,
					state,
					zip,
					id: this.cityId
				};

				const { errors } = await this.onCitiesSave(values);
				if (!errors) {
					this.setAlert({ type: "success", message: "Saving Successfully" });
					this.onClose(1);
				}
			} else {
				this.setAlert({ type: "error", message: "Saving error" });
			}
		},
	},
	async mounted() {
		if (this.cityId) {
			await this.getCitiesItem(this.cityId);
			const { city, state_id, zip } = this.citiesItem;
			zip.forEach(item => {
				this.$set(item, 'disabled', true);
			});
			this.city = city;
			this.state = state_id;
			this.zipList = zip;
		}
	}
};
</script>

<style scoped lang="scss">
	.dividerTitle {
		color: var(--card-color-sub-title);
		font-size: 14px;
		font-style: normal;
		font-weight: 500;
		line-height: 20px;
		letter-spacing: 0.25px;
		margin-bottom: 10px;
		&:after {
			content: '*';
			color: var(--base-red);
		}
	}

	.notText {
		color: var(--card-color-sub-title);
		font-size: 12px;
		&.errorText {
			color: var(--base-red);
			margin-top: 6px;
		}
	}

	.zip {
		display: flex;
		align-items: center;
		position: relative;
		margin-bottom: 10px;

		&Btn {
			display: flex;
			align-items: center;
			position: absolute;
			right: 0;
			top: 10px;
			bottom: 10px;

			button {
				margin-right: 10px;
				color: var(--base-green);
			}
		}
		
		&:not(.disabled) {
			border: 1px solid  var(--base-green);
			box-shadow: 2px 4px 10px 0 var(--card-shadow);
			border-radius: 4px;
			caret-color: var(--base-green);

			.zipBtn_edit {
				color: var(--base-green);
			}
		}
		&.new {
			.field {
				background: var(--base-yellow-opacity);
			}
		}

	}

</style>
